import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import {
  ParsedCSVResponse,
  TransactionMatchResult,
  DuplicateCheckResult,
} from 'shared';

export const bankImportApi = {
  async parseCSV(file: File): Promise<ParsedCSVResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(
      `${API_BASE_URL}/api/payments/parse-csv`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data.data;
  },

  async matchTransaction(data: { name: string; purpose: string; amount: number }): Promise<TransactionMatchResult> {
    const response = await axios.post(
      `${API_BASE_URL}/api/payments/match-transaction`,
      data
    );
    return response.data.data;
  },

  async checkDuplicate(data: { amount: number; receiveDate: string; bankReference?: string }): Promise<DuplicateCheckResult> {
    const response = await axios.post(
      `${API_BASE_URL}/api/payments/check-duplicate`,
      data
    );
    return response.data.data;
  },
};
